import { UsersState } from 'types/app/users';

export const usersInitialState: UsersState = {
  total: 0,
  per_page: 10,
  current_page: 1,
  last_page: 1,
  data: [],
};
